import { Component, Input, OnInit, HostBinding } from "@angular/core";
import { IdService } from "../shared/services/id.service";


@Component({
	selector: "rbc-link-card",
	templateUrl: "./link-card.component.html",
	styles: []
})
export class LinkCardComponent {

	get localLayout() {
		if (this.getLayout) {
			return this.getLayout;
		} else {
			return this.layout;
		}
	}
	get localColumns() {
		if (this.getColumns) {
			return this.getColumns;
		} else {
			return this.columns;
		}
	}

	get classGen() {
		let classes = {};

		classes["rbc-link-card-" + this.localLayout] = this.localLayout;
		classes["list-divider-item"] = this.localLayout === "list";
		return classes;
	}

	// get columnsClassGen() {
	// 	let classes = {};
	// 	if (this.localLayout === "card") {
	// 		classes["rbc-card-group-col"] = true ? this.localColumns : null;
	// 		classes["rbc-card-col-my"] = this.localColumns || this.localLayout === "card" && !this.localColumns;
	// 		classes["col-sm-6"] = this.localColumns === 2;
	// 		classes["col-md-4 col-sm-6"] = this.localColumns === 3;
	// 		classes["col-xl-3 col-md-4 col-sm-6"] = this.localColumns === 4;
	// 		classes["rbc-link-card-col"] = this.localLayout === "card" && !this.localColumns;
	// 		console.log(classes)
	// 		return classes;
	// 	} else {
	// 		return null;
	// 	}
	// }

	@Input() id: string;
	@Input() layout = "card";
	@Input() title: string;
	@Input() text: string;
	@Input() icon: string;
	@Input() iconWeight = "solid";
	@Input() iconLabel: string;
	@Input() link: string;
	@Input() target: string;
	@Input() marker: string;
	@Input() columns: number;

	getLayout = false;
	getColumns = false;

	@HostBinding("class.rbc-link-card") public cardLink = true;
	@HostBinding("class.rbc-card-group-col") public cardGroupCol;
	@HostBinding("class.rbc-card-col-my") public cardCol;
	@HostBinding("class.col-sm-6") public cardSm;
	@HostBinding("class.col-md-4") public cardMd;
	@HostBinding("class.col-xl-3") public cardXl;
	@HostBinding("class.rbc-link-card-col") public cardLinkCard;

	constructor(private idService: IdService) {
		this.id = idService.generate();
		// this.cardGroupCol = true;
		this.cardCol = this.localColumns || this.localLayout === "card" && !this.localColumns;
		this.cardSm = this.localColumns === 2 || this.localColumns === 3 || this.localColumns === 4;
		this.cardMd = this.localColumns === 3 || this.localColumns === 4;
		this.cardXl = this.localColumns === 4;
		this.cardLinkCard = this.localLayout === "card" && !this.localColumns;

	}
}
